export const PIKKO_APP_DEEPLINK = 'https://pikkoapp.netlify.app/5e';
